import type { OrderDetail, OrderSearchData, OrderStatus, OrderSummary } from "@/lib/order-types";

const placedAt = ["2026-08-19T07:00:00Z", "2026-08-19T05:00:00Z", "2026-08-19T00:00:00Z", "2026-08-17T20:00:00Z"];
const statuses: OrderStatus[] = ["PENDING_PAYMENT", "PAID", "PARTIALLY_SHIPPED", "COMPLETED"];
const ids = [
    "11111111-1111-4111-8111-111111111111",
    "22222222-2222-4222-8222-222222222222",
    "33333333-3333-4333-8333-333333333333",
    "44444444-4444-4444-8444-444444444444",
];

export const demoOrders: OrderSummary[] = ids.map((id, index) => ({
    id,
    order_number: `ORD-20260819-${String(index + 1).padStart(4, "0")}`,
    external_order_number: `TM-20260819000${index + 1}`,
    channel: index % 2 === 0 ? "TMALL" : "WECHAT",
    status: statuses[index],
    payment_status: index === 0 ? "UNPAID" : "PAID",
    fulfillment_status: index < 2 ? "UNFULFILLED" : index === 2 ? "PARTIALLY_FULFILLED" : "FULFILLED",
    currency: "CNY",
    total_minor: 18700,
    paid_minor: index === 0 ? 0 : 18700,
    item_count: 3,
    customer_name_masked: "林*",
    placed_at: placedAt[index],
    updated_at: placedAt[index],
    version: 1,
}));

export const demoOrderSearch: OrderSearchData = {
    items: demoOrders,
    total: demoOrders.length,
    page: 1,
    page_size: 20,
};

export const demoOrderDetails: Record<string, OrderDetail> = Object.fromEntries(
    demoOrders.map((order) => [
        order.id,
        {
            ...order,
            subtotal_minor: 20700,
            discount_minor: 2000,
            shipping_minor: 0,
            tax_minor: 0,
            customer_phone_masked: "138****1042",
            shipping_address_masked: "上海市浦东新区****路**号",
            created_at: order.placed_at,
            items: [
                {
                    id: `${order.id.slice(0, 8)}-aaaa-4aaa-8aaa-aaaaaaaaaaaa`,
                    sku: "SKU-COFFEE-01",
                    product_name: "手冲咖啡礼盒",
                    variant: "经典风味",
                    quantity: 1,
                    unit_price_minor: 12900,
                    discount_minor: 0,
                    line_total_minor: 12900,
                },
                {
                    id: `${order.id.slice(0, 8)}-bbbb-4bbb-8bbb-bbbbbbbbbbbb`,
                    sku: "SKU-MUG-02",
                    product_name: "双层玻璃杯",
                    variant: "透明 350ml",
                    quantity: 2,
                    unit_price_minor: 3900,
                    discount_minor: 0,
                    line_total_minor: 7800,
                },
            ],
            events: [
                {
                    id: `${order.id.slice(0, 8)}-cccc-4ccc-8ccc-cccccccccccc`,
                    event_type: "ORDER_CREATED",
                    from_status: null,
                    to_status: "PENDING_PAYMENT",
                    actor_label: "交易系统",
                    message: "订单已同步至订单中心",
                    occurred_at: order.placed_at,
                },
                ...(order.status === "PENDING_PAYMENT"
                    ? []
                    : [
                          {
                              id: `${order.id.slice(0, 8)}-dddd-4ddd-8ddd-dddddddddddd`,
                              event_type: "PAYMENT_CONFIRMED",
                              from_status: "PENDING_PAYMENT",
                              to_status: "PAID",
                              actor_label: "支付适配器",
                              message: "支付状态已确认",
                              occurred_at: order.updated_at,
                          },
                      ]),
            ],
        },
    ]),
);

export const defaultDemoOrderDetail = demoOrderDetails[demoOrders[0].id];
